import React, { createContext, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useReducer } from 'reinspect';

const OlimpicStateContext = createContext();
const OlimpicActionsContext = createContext();

export function useOlimpicState() {
  return useContext(OlimpicStateContext);
}

const initialState = {
  dialogVisible: false,
  timerPeriod: 3,
  olimpic: {
    timer: {
      begin: false,
      progress: false,
      end: false,
      start: false,
      stop: false,
    },
  },
};

export const types = {
  TOGGLE_DIALOG_VISIBLE: 'TOGGLE_DIALOG_VISIBLE',
  ON_CERTIFICATION_TIMER_START: 'ON_CERTIFICATION_TIMER_START',
  ON_CERTIFICATION_TIMER_STOP: 'ON_CERTIFICATION_TIMER_STOP',
  ON_CERTIFICATION_TIMER_RESET: 'ON_CERTIFICATION_TIMER_RESET',
  ON_CERTIFICATION_TIMER_BEGIN: 'ON_CERTIFICATION_TIMER_BEGIN',
  ON_CERTIFICATION_TIMER_PROGRESS: 'ON_CERTIFICATION_TIMER_PROGRESS',
  ON_CERTIFICATION_TIMER_END: 'ON_CERTIFICATION_TIMER_END',
  UPDATE_PROP: 'UPDATE_PROP',
};

export function useOlimpicActions() {
  const { dispatch } = useContext(OlimpicActionsContext);
  function onStart() {
    dispatch({
      type: types.ON_CERTIFICATION_TIMER_START,
    });
  }
  function onStop() {
    dispatch({
      type: types.ON_CERTIFICATION_TIMER_STOP,
    });
  }
  function onEnd() {
    dispatch({
      type: types.ON_CERTIFICATION_TIMER_END,
    });
  }

  function onReset() {
    dispatch({
      type: types.ON_CERTIFICATION_TIMER_RESET,
    });
  }
  function onProgress() {
    dispatch({
      type: types.ON_CERTIFICATION_TIMER_PROGRESS,
    });
  }
  function updateProp(key, value) {
    dispatch({
      type: types.UPDATE_PROP,
      meta: key,
      payload: value,
    });
  }
  function toggleDialogVisible() {
    dispatch({
      type: types.TOGGLE_DIALOG_VISIBLE,
    });
  }

  return {
    onStart,
    onEnd,
    onStop,
    onReset,
    onProgress,
    updateProp,
    toggleDialogVisible,
  };
}

function reducer(state, action) {
  switch (action.type) {
    case types.ON_CERTIFICATION_TIMER_START:
      return {
        ...state,
        olimpic: {
          timer: {
            start: true,
            stop: false,
            begin: false,
            end: false,
            progress: false,
          },
        },
      };
    case types.ON_CERTIFICATION_TIMER_STOP:
      return {
        ...state,
        olimpic: {
          timer: {
            start: false,
            stop: true,
            begin: false,
            end: false,
            progress: false,
          },
        },
      };
    case types.ON_CERTIFICATION_TIMER_END:
      return {
        ...state,
        olimpic: {
          timer: {
            start: false,
            stop: false,
            begin: false,
            end: true,
            progress: false,
          },
        },
      };
    case types.ON_CERTIFICATION_TIMER_PROGRESS:
      return {
        ...state,
        olimpic: {
          timer: {
            start: false,
            stop: false,
            begin: true,
            end: false,
            progress: true,
          },
        },
      };
    case types.ON_CERTIFICATION_TIMER_RESET:
      return {
        ...state,
        olimpic: {
          timer: {
            start: false,
            stop: false,
            begin: false,
            end: false,
            progress: false,
          },
        },
      };
    case types.TOGGLE_DIALOG_VISIBLE:
      return {
        ...state,
        dialogVisible: !state.dialogVisible,
      };
    case types.UPDATE_PROP:
      return {
        ...state,
        [action.meta]: action.payload,
      };

    default:
      return state;
  }
}

export function OlimpicContextProvider({ children }) {
  const [state, dispatch] = useReducer(
    reducer,
    initialState,
    undefined,
    'OLIMPIC'
  );

  const actions = useMemo(
    () => ({
      dispatch,
    }),
    []
  );

  return (
    <OlimpicStateContext.Provider value={state}>
      <OlimpicActionsContext.Provider value={actions}>
        {children}
      </OlimpicActionsContext.Provider>
    </OlimpicStateContext.Provider>
  );
}

OlimpicContextProvider.propTypes = {
  children: PropTypes.object.isRequired,
};
